export const eventTypes = {
  cmpReady: 'cmpReady',
};

export const storageKeys = {
  wishlist: 'wishlist',
  wishlistV2: 'wishlist_v2',
  wishlistLegacyBackup: 'wishlist_v2_legacy_backup',
  customerHash: 'survey_hash',
  surveysSeen: 'surveys_seen',
};

export const urlParams = {
  accessToken: 'productListAccessToken',
};

export const globalUserMessageDataKey = {
  globalUserMessage: 'globalUserMessage',
};
